<!doctype html>
<html lang="en">

<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    <title>Konnect Water Solution</title>
    <link rel="shortcut icon" href="assets/images/fav.png" type="image/x-icon">

    <style>
        @media (min-width:600px) {


            .card2 {
                min-height: 300px;
                margin: 5px;
                font-size: 16px;
            }

            .logo {
                max-width: 200px !important;
            }
        }

        @media (max-width:600px) {
            .row {
                margin: 0px;
            }

            .carousel-inner {
                margin-top: 25px;
            }

            .card2 {
                min-width: 250px;
                font-size: 11px !important;
                margin: 2px;
                min-height: 280px !important;
            }

            .img2 {
                width: 50px !important;
                height: 50px !important
            }

            .title_card {
                font-size: 14px !important;
            }

            .title_card2 {
                font-size: 18px !important;
            }

            .container-xl {
                padding-left: 0px;
                padding-right: 0px
            }

            .big-padding {
                padding: 0px
            }

            .px-3 {
                padding: 0px !important
            }

            .container-lg {
                margin: 0px;
                padding: 0px;
            }

        }

        .big-padding {
            padding-top: 100px !important;
        }
    </style>
</head>

<body class="bg-white">
    <header>
        <div id="menu-jk" class="nav-part shadow-md bg-white navcol">
            <div class="container-lg">
                <div class="row  p-2">
                    <div class="col-lg-3 p-2" style="display:flex;flex-direction:row;align-items:center">

                        <a href="index.html" style="max-width:200px">
                            <img class="'logo" src="assets/images/logo.png" alt="">
                        </a>
                        <div class='d-lg-none'
                            style="flex:1;font-size:13px;padding-right:0px;display:flex;flex-direction:column;justify-content:center;align-items:flex-end;">
                            <div>Contact us</div>
                            <div style="font-weight:bold;">0701888666</div>
                        </div>
                    </div>
                    <div id="menu" class="col-lg-9 d-none pt-1 d-lg-block"
                        style="display:flex;flex-direction:row;align-items:center">

                        <div
                            style="flex:1;padding-right:20px;display:flex;flex-direction:column;justify-content:center;align-items:flex-end;">
                            <div class="d-none pt-1 d-lg-block">Contact us</div>
                            <div class="d-none pt-1 d-lg-block" style="font-weight:bold">0701888666</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </header>
    <div class="about-us big-padding">
        <div class="container-lg">

            <div class="col-md-7" style="width: 100%;padding:5px">
                <div class="abut-detail fs-6"
                    style="text-align:center;width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center">

                    <h2> Maintenance Notice</h2>
                    <div class="col-md-5 p-4"
                        style="width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center">
                        <img src="assets/images/services/notice.jpg" alt=""
                            style="width:40%;min-width:340px;max-width:600px">
                    </div>
                    We are currently performing maintenance. We apologize for any inconvenience this may cause.
                    <br />
                    <div class="alert alert-primary" role="alert">
                        Please feel free to contact us for any inquiry<br />call us on +254701888666
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footer>
        <div class="inner">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 ">
                        <h5>About us</h5>
                        <p style="font-size:12px;">At Konnect, we are passionate about providing convenient and
                            sustainable drinking water solutions.</p>
                        <p style="font-size:12px;">With our state-of-the-art water purification and dispensing machines,
                            users can refill their reusable bottles on the go, saving money and reducing their
                            environmental impact. We strive to make clean drinking water accessible to everyone while
                            promoting sustainability and reducing plastic pollution.</p>
                        <p style="font-size:12px;">Join us in our mission to create a greener and healthier future by
                            choosing the Konnect Water Solution for your hydration needs.</p>
                    </div>
                    <div class="col-md-3">
                    </div>
                    <div class="col-md-3"> <br />
                        <h5>Contact Us</h5>
                        <address>
                            Zimmerman, Roysambu<br>
                            Kasarani, Nairobi<br>
                            Kenya<br>
                            <br>
                            Phone: +254701888666
                        </address>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col text-center">
                        <p>&copy; 2023 Konnect Water Solution. All rights reserved</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</body>

</html>